import { Path } from 'slate';
import { defineTransform } from '../transform';

import {
  adjustPositionForNodeMove,
  adjustPathForNodeSplit,
  adjustPathForNodeMerge,
  adjustPathForNodeInsert,
  adjustPathForNodeRemove,
} from '../utils';

defineTransform('insert_node', 'insert_text', (op1, op2, side) => op1);
defineTransform('insert_node', 'remove_text', (op1, op2, side) => op1);
defineTransform('insert_node', 'split_node', (op1, op2, side) => {
  // Insert has precedence over split
  if (
    Path.equals(op1.path.slice(0, -1), op2.path) &&
    op2.position === op1.path[op1.path.length - 1]
  ) {
    return op1;
  }

  return {
    ...op1,
    path: adjustPathForNodeSplit(op1.path, -1, op2, side === 'left'),
  };
});

defineTransform('insert_node', 'merge_node', (op1, op2, side) => {
  return {
    ...op1,
    path: adjustPathForNodeMerge(op1.path, op2, false),
  };
});

defineTransform('insert_node', 'move_node', (op1, op2, side) => {
  return {
    ...op1,
    path: adjustPositionForNodeMove(op1.path, op2, side === 'right'),
  };
});

defineTransform('insert_node', 'insert_node', (op1, op2, side) => {
  return {
    ...op1,
    path: adjustPathForNodeInsert(op1.path, op2, side === 'right'),
  };
});

defineTransform('insert_node', 'remove_node', (op1, op2, side) => {
  const tOp = { ...op1 };
  if (Path.isAncestor(op2.path, op1.path)) return;
  tOp.path = adjustPathForNodeRemove(tOp.path, op2);
  return tOp;
});

defineTransform('insert_node', 'set_node', (op1, op2, side) => op1);
defineTransform('insert_node', 'add_mark', (op1, op2, side) => op1);
defineTransform('insert_node', 'remove_mark', (op1, op2, side) => op1);
defineTransform('insert_node', 'set_mark', (op1, op2, side) => op1);
defineTransform('insert_node', 'add_annotation', (op1, op2, side) => op1);
defineTransform('insert_node', 'remove_annotation', (op1, op2, side) => op1);
defineTransform('insert_node', 'set_annotation', (op1, op2, side) => op1);
defineTransform('insert_node', 'set_selection', (op1, op2, side) => op1);
defineTransform('insert_node', 'add_metadata', (op1, op2, side) => op1);
defineTransform('insert_node', 'remove_metadata', (op1, op2, side) => op1);
defineTransform('insert_node', 'set_metadata', (op1, op2, side) => op1);
